module.exports = __webpack_public_path__ + "static/media/grey-clock-icon.3f780294.svg";